import { useContext } from "react";
import useRouteLineService from "../../../../hooks/useRouteLineService";
import ImportTable from "../ImportTable/ImportTable";
import TriggerImport from "./ImportActions";
import { LayerContext } from "../LayerContext";
import TableActionButton from "../../../../@ui/TableActionButton";
import { TableActionButtonDelete } from "../../../../@ui/TableActionButtonDelete";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const StyledDeleteButton = styled(TableActionButtonDelete)`
  margin-right: 0.5rem;
`;

const RouteLinesLayer = () => {
  const routeLineService = useRouteLineService();
  const layerContext = useContext(LayerContext);
  const navigate = useNavigate();

  return (
    <>
      <div className="mr-1 w-100 text-end mb-1">
        <StyledDeleteButton
          onClick={() => navigate("/admin/layers/Basemap:RouteLine/delete")}
        >
          Delete
        </StyledDeleteButton>
        <TriggerImport
          service={routeLineService}
          onSubmitted={() => {
            layerContext?.refreshLayerInfo();
          }}
        />
      </div>

      <ImportTable />
    </>
  );
};

export default RouteLinesLayer;
